module.exports = __webpack_public_path__ + "img/machine-washable.aa962a5.svg";